import { fetchAbortController, conditionallyRemoveViewByFilters } from '../../utils/common';
import { getAggregations as getAggregationsAPI } from '../../utils/API';
import { queryClient, getLanguage } from '../../utils/queriesUtil';

export const getAggregations = async (apiEndpoint, aggregationParams, pagination) => {
  const abortController = fetchAbortController();
  const signal = abortController ? abortController.signal : null;
  return getAggregationsAPI(apiEndpoint, aggregationParams, pagination, signal).then(response => response.data);
};

export const getOptions = async aggregationQuery => {
  const { aggregation_type } = aggregationQuery?.query;
  const pagination = { limit: aggregation_type === 'year_id' || aggregation_type === 'season_id' ? 1000 : 10 };
  const validQuery = conditionallyRemoveViewByFilters(aggregationQuery.query);
  const queryKey = [getLanguage(), 'GET_AGGREGATION', JSON.stringify({ ...validQuery })];
  if (typeof queryClient.getQueryData(queryKey) !== 'undefined') {
    return Promise.resolve(queryClient.getQueryData(queryKey));
  }
  const optionsPromise = await queryClient.fetchQuery(
    queryKey,
    async () => getAggregations(aggregationQuery.endpoint, validQuery, pagination),
    {
      refetchOnWindowFocus: false,
      staleTime: 0,
      initialStale: true,
      onSuccess: () => {},
    },
  );
  return optionsPromise;
};
